import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo/atlassian/logo';

const LogoBlue = (): React.JSX.Element => {
	return <AtlassianLogo appearance="brand" />;
};

export default LogoBlue;
